<template>
    <div class="modal fade" id="register-store-modal" role="dialog" aria-labelledby="myLargeModalLabel" tabindex="-1">
        <div class="flash-message" style="display: none;">
            <div class="alert alert-success">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">x</span>
                </button>
            </div>
        </div>
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header text-center">
                    <h5 class="text-left modal-title">Ativar cadastro na loja virtual</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>

                <div class="modal-body text-center bold">
                    <div class="col-md-12">
                        <p>
                            1. Clique no botão para ativar seu cadastro.
                        </p>

                        <br>

                        <p>
                            2. Será enviado um link de confirmação para o mesmo
                            <br>
                            e-mail que você utiliza para entrar no TAGSELL.
                        </p>

                        <br>

                        <p>
                            3. Após a confirmação, seu cadastro na loja estará pronto e vinculado
                            <br>
                             à sua conta TAGSELL. Assim, as licenças e campanhas compradas serão liberadas
                            <br>
                            automaticamente após a confirmação de pagamento.
                        </p>

                        <br>

                        <p>
                            4. Você também receberá um e-mail de boas-vindas contendo
                            <br>
                            sua senha para entrar na loja e um link onde você poderá visualizar todos os
                            <br>
                            dados de sua conta.
                        </p>

                        <br>

                        <p v-if="successLinked" class="success-message text-success">
                            <i class="fa fa-check-circle-o text-success fa-2x md-mr-5"></i>
                            Cadastrado ativado com sucesso!
                        </p>

                        <div class="col-md-12 d-flex justify-center activate-button-div">
                            <button
                                v-if="!showStoreLink"
                                type="button"
                                @click="linkStore()"
                                class="text-uppercase bold btn btn-outline-secondary waves-effect waves-light col-lg-4 col-md-12 col-sm-12">
                                ativar
                                <i v-if="requesting" class="fa fa-spin fa-circle-o-notch"></i>
                            </button>

                            <a
                                v-else
                                target="_blank"
                                href="https://loja.tagsell.com.br/minha-conta/"
                                class="text-uppercase bold btn btn-outline-secondary waves-effect waves-light col-lg-4 col-md-12 col-sm-12">
                                Ir para Loja
                            </a>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'modal-register-store',

    props: {
      linkStoreUrl: String,
    },

    data() {
      return {
        requesting: false,
        successLinked: false,
        showStoreLink: false,
      };
    },

    methods: {
      linkStore() {
        this.requesting = true;
        axios.post(this.linkStoreUrl).then((response) => {
          this.successLinked = true;
          this.showStoreLink = true;

          this.$root.throwFlashMessage(response.data.type, response.data.message);
        }).catch((error) => {
          if (error.response.status === 300)
            this.showStoreLink = true;

          this.$root.throwFlashMessage(error.response.data.type, error.response.data.message);
        }).finally(() => this.requesting = false);
      },
    },
  };
</script>

<style scoped>
    .btn-tagsell {
        background-color: #ED1763;
        color: #fff;
    }

    @media screen and (max-width: 768px){
        .btn-tagsell {
            display: block;
            width: 100%;
        }
    }

    .panel-body p {
        color: #7b7b7b;
        font-size: 1.2em;
        margin-top: 15px;
        font-weight: 500;
    }

    .d-flex {
        display: flex;
    }

    .justify-center {
        justify-content: center;
    }

    .activate-button-div {
        margin: 20px 0;
    }

    .success-message {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.2em;
        margin-top: 15px;
        color: #7accbe !important;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ModalRegisterStore.vue